<div class="tos-overlay">
    <div class="tos-modal">

        <div class="tos-header">
            <h3>Updated Terms of Service</h3>
        </div>

        <div class="tos-body">
            <ng-container *ngIf="!tosService.recoveryRequired; else RecoveryMessage">
            <p class="intro-text">
                Before you continue to Opogo Education please review and agree to the updated Terms of Service.
            </p>

            <p class="sub-text">
                This will ensure you understand your responsibilities when booking and managing {{ localizedLabel.Candidates | localizeText }}.
            </p>

            <div class="checkbox-container">
                <label class="custom-checkbox">
                    <input type="checkbox" [(ngModel)]="isChecked" [disabled]="isSubmitting">
                    <span class="label-text">
            I agree to Opogo Education’s 
            <a [href]="tosUrl" target="_blank">Terms of service</a>
          </span>
                </label>
            </div>
            <p *ngIf="hasSubmissionError" class="submission-error" role="alert">
                Unable to save your acceptance. Please try again.
            </p>
            </ng-container>
            <ng-template #RecoveryMessage>
                <p class="submission-error" role="alert">
                    Unable to confirm your Terms of Service acceptance. Please try again or sign out.
                </p>
            </ng-template>
        </div>

        <div class="tos-actions">
            <button class="btn-reject" (click)="onReject()" [disabled]="isSubmitting">
                {{ tosService.recoveryRequired ? 'Sign out' : 'Reject' }}
            </button>

            <button *ngIf="tosService.recoveryRequired" class="btn-agree" (click)="onRetry()" [disabled]="isSubmitting">
                Retry
            </button>

            <button
                    *ngIf="!tosService.recoveryRequired"
                    class="btn-agree"
                    (click)="onAgree()"
                    [disabled]="!isChecked || isSubmitting">
                Agree
            </button>
        </div>

    </div>
</div>
